import { render, staticRenderFns } from "./exodus-teams.vue?vue&type=template&id=7bb32ac2&"
import script from "./exodus-teams.vue?vue&type=script&lang=js&"
export * from "./exodus-teams.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports